import React from 'react';

export const FlagCzRound = () => {
  return (
    <svg width="36" height="36" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M21 39C30.9411 39 39 30.9411 39 21C39 11.0589 30.9411 3 21 3C11.0589 3 3 11.0589 3 21C3 30.9411 11.0589 39 21 39Z"
        fill="#D6292B"
      />
      <path
        d="M21 3C16.2261 3 11.6477 4.89642 8.27206 8.27208C4.89641 11.6477 3 16.2261 3 21H39C39 16.2261 37.1036 11.6477 33.7279 8.27208C30.3523 4.89642 25.7739 3 21 3Z"
        fill="#E4E4E4"
      />
      <path
        d="M8.40601 8.15027C6.69464 9.82413 5.33485 11.823 4.40652 14.0295C3.4782 16.2361 3 18.6058 3 20.9996C3 23.3935 3.4782 25.7632 4.40652 27.9698C5.33485 30.1763 6.69464 32.1752 8.40601 33.849L21.255 21L8.40601 8.15027Z"
        fill="#2A81BC"
      />
    </svg>
  );
};
